export default "__VITE_ASSET__aQ3NJQXi__"